<!-- 用户日用量告警页面 -->
<template>
<a-row :gutter="24" class="new-row">
  <a-col :sm="24" :md="collapsed? 0: 5" class="new-col">
    <a-card :bordered="false" class="new-tree-card">
      <!-- 按钮操作区域 -->
      <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
        <a-alert type="info" :showIcon="true">
          <div slot="message">
            {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
            <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
          </div>
        </a-alert>
        <div style="display: flex;margin-top: 10px;">
          <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
          <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
        </div>
        <!-- 树-->
        <a-col :md="24" :sm="24" class="new-tree-col">
          <template>
            <a-spin tip="Loading..." :spinning="areaLoading">
              <!--
              <span style="user-select: none">
                <a-tree
                  class="my-area-select-tree"
                  :selectedKeys="selectedKeys"
                  :treeData="areaTree"
                  :checkStrictly="checkStrictly"
                  :expandedKeys="iExpandedKeys"
                  :autoExpandParent="autoExpandParent"
                  selectable
                  @expand="onExpand"
                  @select="onSelect">
                  <template slot="title" slot-scope="{title}">
                    <span v-if="title.indexOf(searchAreaValue) > -1">
                      {{title.substr(0, title.indexOf(searchAreaValue))}}
                    <span style="color: #32CD32">{{searchAreaValue}}</span>
                      {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                    </span>
                    <span v-else>{{title}}</span>
                  </template>
                </a-tree>
              </span>
              -->
              <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
            </a-spin>
          </template>
        </a-col>
      </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed" ></a-icon>
    <a-card :bordered="false" class="new-table-card">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户编号')">
                <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <a-input :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName "></a-input>
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('处理状态')">
                  <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                    <a-select-option value="0">
                      {{ $t('未处理') }}
                    </a-select-option>
                    <a-select-option value="1">
                      {{ $t('处理中') }}
                    </a-select-option>
                    <a-select-option value="2">
                      {{ $t('已处理') }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('价格名称')">
                  <a-select v-model="queryParam.waterTypeId" :placeholder="$t('请选择价格名称')">
                    <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.id">
                      {{data.wtName}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!--
              <a-col :xl="10" :lg="11" :md="12" :sm="24">
                <a-form-item label="用户余额范围">
                  <a-input-number v-model="queryParam.minValue" :precision="2" />
                  -
                  <a-input-number v-model="queryParam.maxValue" :precision="2" />
                  元
                </a-form-item>
              </a-col>
              -->
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div class="table-operator">
        <a-button type="primary" icon="download" @click="handleExportXls($t('用户明细'))">{{ $t('导出') }}</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDeal"><a-icon type="edit"/>{{ $t('批量处理') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px" v-has="'meteruser:batchdelete'"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
      </div>
      <div class="table-fixed">
        <a-table
          ref="table"
          size="middle"
          tableLayout="fixed"
          :scroll="{x:1500}"
          bordered
          rowKey="userKeyId"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          :components="drag(columns)"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll}"
          @change="handleTableChange">
          <span slot="wtPriceSlot" slot-scope="text, record">
            <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
            <span v-else>--</span>
          </span>
          <span slot="meterDealStatus" slot-scope="text, record">
            <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
            <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
            <label v-else class="wait-status">{{ $t('未处理') }}</label>
          </span>
          <span slot="action" slot-scope="text, record" class="action">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
            <a :disabled="record.meterDealStatus == 2" @click="handleDeal(record)">{{ $t('处理') }}</a>
          </span>
        </a-table>
      </div>
      <meter-use-warn-record-modal ref="modalForm" @ok="modalFormOk"></meter-use-warn-record-modal>
      <meter-use-warn-record-deal-modal ref="dealModalForm" @ok="modalFormOk"></meter-use-warn-record-deal-modal>
    </a-card>
  </a-col>
</a-row>
</template>

<script>
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUseWarnRecordModal from './modules/meterUseWarnRecordModal'
  import MeterUseWarnRecordDealModal from './modules/meterUseWarnRecordDealModal'
  import { listSize } from '@/utils/util'
  import { httpAction, getAction } from '@/api/manage'
  import { isUndefinedAndNull } from '@/utils/validate'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Vue from 'vue'
  export default {
    name: 'MeterUseWarnRecordList',
    mixins:[JeecgListMixin, mixinDevice, AreaChoosetMixin,TableDragResize],
    components: {
      MeterUseWarnRecordModal,
      MeterUseWarnRecordDealModal
    },
    data () {
      return {
        description: 'meter_user_account管理页面',
        collapsed: false,
        //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/meterUseWarnLastRecord/list",
          delete: "/jeecg-charge/meter/meterUseWarnLastRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterUseWarnLastRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUseWarnLastRecord/exportXls",  //导出接口
          importExcelUrl: "jeecg-charge/meter/meterUseWarnLastRecord/importExcel",
          userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",  
        },
        dictOptions:{},
        userPriceCode:[], // 价格编码
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.initColumns();
      this.queryUserPriceCode()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon', }
          },{
            title: this.$t('区域名称'),
            align:"center",
            dataIndex: 'userAreaName',
            width: 100,
            ellipsis: true
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId',
            width: 150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },/*{
            title:'告警描述',
            align:"center",
            dataIndex: 'meterWarnDetail',
            width: 100,
            ellipsis: true,
          },*/{
            title: this.$t('告警规则'),
            align:"center",
            dataIndex: 'warnName',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('日用量(m³)'),
            align:"center",
            dataIndex: 'dayUse',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('报表日期'),
            align:"center",
            dataIndex: 'reportDate',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('价格信息'), //对应priceinfo表中的主键id
            align:"center",
            dataIndex:'wtPrice',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'wtPriceSlot' },
          },{
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:80,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        
        if(isUndefinedAndNull(this.queryParam.accountAlarmType)) {
          this.queryParam.accountAlarmType = 1;
        }
        
        console.log(typeof(this.queryParam.accountAlarmType))
        console.log(this.queryParam.accountAlarmType)
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      queryUserPriceCode() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
            console.log(this.userPriceCode);
          }
        }) 
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      handleDeal(record) {
        this.$refs.dealModalForm.edit(record);
        this.$refs.dealModalForm.title=this.$t("详情");
        this.$refs.dealModalForm.disableSubmit = false;
      },
      batchDeal() {
        console.log(this.selectionRows)
        let isPendingState = true;
        let meterIdList = "";
        let idList = "";
        for(let i =0;i<this.selectionRows.length;i++) {
          if(this.selectionRows[i].meterDealStatus !== 0) {
            isPendingState = false
            break;
          }
          if(i!=0) {
            meterIdList += ","+this.selectionRows[i].meterId
            idList += ","+this.selectionRows[i].userKeyId
          }else{
            meterIdList += this.selectionRows[i].meterId
            idList += this.selectionRows[i].userKeyId
          }
        }
        if(!isPendingState) {
          this.$message.error(this.$t("只能批量选择未处理的记录！"))
          return;
        }
        let record = {meterIdList: meterIdList,idList: idList}
        this.handleDeal(record)
      }
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>
<style scoped>
  .table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table{
    border-right: 1px solid #e8e8e8;
  }

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border:1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}

</style>